import * as React from 'react';
import { connect } from 'react-redux';
import { Page } from 'components/page-container';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { fetchHistoryLog, fetchHistoryLogCostAndRevenue, fetchBlob } from 'actions/historyLog';
import { IStore } from 'reducers/index';
import { HandleError } from 'components/handle-error';
import { InPageDialog } from 'damco-components';
import { historyLogCols, historyLogRevenueCols, historyLogCostCols } from 'constants/tableConstants';
import { Accordion } from 'damco-components';
import { DataTable } from 'damco-components';
import { IHistoryLogModel } from 'reducers/historyLog/models';
import { formatDate, formatValueIfNullOrUndefined, sortElementByKey, getType } from 'utilities/util';
import ActionTexts from 'constants/historyLogActionTexts.json';
import { ModalType } from 'components/modal-screen/ModalType';
import { ModalScreen } from 'components/modal-screen';

interface IParams {
    shipmentId: string;
    shipmentType: any;
    invoiceType?: string;
    isSourceAthena?: boolean;
    enableBlockedType?: boolean;
    isNftpBillable?: boolean;
}

interface IMapDispatchToProps {
    fetchHistoryLog: (shipmentId: string, shipmentType: string | number) => Promise<void>;
    fetchHistoryLogCostAndRevenue: (shipmentId: string, shipmentType: string | number) => Promise<void>;
    fetchBlob: (shipmentId: string) => Promise<void>;
}
interface IMapStateToProps {
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    pendingError: string | string[],
    response: IHistoryLogModel[];
    costAndRevenue: any,
    blob: any;
}

interface IProps extends IParams, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    pendingError: string | string[];
    showDialog: boolean;
    showMessageDetailsModal: boolean;
    messageDetails: any;
    cost: any[],
    revenue: any[],
    cvTotalCount: number,
    response: any[],
    showLoading: boolean;
}
export class _HistoryLog extends React.Component<IProps, IState> {
    public refCost = React.createRef<any>();
    public refRev = React.createRef<any>();
    constructor(props: any) {
        super(props);
        this.state = {
            pendingError: '',
            showDialog: false,
            showMessageDetailsModal: false,
            messageDetails: '{}',
            cost: [],
            revenue: [],
            response: [],
            cvTotalCount: 0,
            showLoading: true
        };
    }
    public componentDidMount = () => {
        if (this.props.shipmentType) {
            this.refCost.current.setState({ isExpanded: false });
            this.refRev.current.setState({ isExpanded: false });
            this.props.fetchHistoryLog(this.props.shipmentType === 4 ? window.location.pathname.split('/')[3] : this.props.shipmentId, this.props.shipmentType);
            this.props.fetchHistoryLogCostAndRevenue(this.props.shipmentId, this.props.shipmentType);
        } else {
            const target: string = this.props.invoiceType && this.props.invoiceType === 'credit' ? 'credit' : 'invoice';
            this.props.fetchHistoryLog(this.props.shipmentId, target);
        }
    };
    public componentDidUpdate = (prevProps: any, prevState: any) => {
        if (this.props.blob !== prevProps.blob) {
            this.setState({
                showMessageDetailsModal: true,
                messageDetails: this.props.blob ? JSON.stringify(this.props.blob, null, 2) : 'No Data found'
            });
        }
        if (this.props.pendingError && this.props.pendingError !== prevProps.pendingError) {
            let checkText = this.props.pendingError;
            if ((Array.isArray(this.props.pendingError) && this.props.pendingError.length === 0) ||
                this.props.pendingError === '') {
                checkText = 'Request has failed. Please try again';
            }
            this.setState({
                showDialog: true,
                pendingError: checkText
            });
        }
        if (this.props.costAndRevenue !== prevProps.costAndRevenue && this.props.costAndRevenue && (this.props.costAndRevenue.data || this.props.costAndRevenue.result)) {
            this.parseCostAndRevenue();
        }
        if (this.props.response !== prevProps.response && this.props.response.length && this.props.response?.length > 0) {
            this.parseResponse();
        }
    };
    public extractDynamicFieldValues = (dynamicFields: string) => {
        try {
            const parsedFields = JSON.parse(dynamicFields);
            if (Array.isArray(parsedFields)) {
                return parsedFields.map(field => field.value).join(', ');
            } else {
                console.error('dynamicFields is not an array', dynamicFields);
                return '';
            }
        } catch (error) {
            console.error('Error parsing dynamic fields', error);
            return '';
        }
    };
    public render() {
        const costAndRevenue = <div className="historyLogRevenueTable">
            <Accordion title={'Revenue Audit Log'} id="revenue-log" ref={this.refRev}>
                <div id={`${this.props.shipmentId}-revenue-history`}>
                    {this.renderTableDom(this.state.revenue, historyLogRevenueCols(this.props.isSourceAthena, this.props.enableBlockedType, this.props.isNftpBillable), 'historyrevenuelog-', 'revenue')}
                </div>
            </Accordion>
            <Accordion title={'Cost Audit Log'} id="cost-log" ref={this.refCost}>
                <div id={`${this.props.shipmentId}-cost-history`}>
                    {this.renderTableDom(this.state.cost, historyLogCostCols(this.props.isSourceAthena, this.props.enableBlockedType, this.props.isNftpBillable), 'historycostlog-', 'cost')}
                </div>
            </Accordion>
        </div>;
        return (
            <React.Fragment>
                <Page>
                    <ModalScreen
                        id={'history-log-modal'}
                        title={'Message Details'}
                        modalType={ModalType.l()}
                        visible={this.state.showMessageDetailsModal}
                        closeModal={() => this.hideMessageDetailsModal()}
                        secondaryButtonFunc={() => this.hideMessageDetailsModal()}
                        primaryButtonTitle="Copy"
                        primaryButtonFunc={() => {
                            const elem = document.createElement('textarea');
                            elem.value = this.state.messageDetails;
                            document.body.appendChild(elem);
                            elem.select();
                            document.execCommand('copy');
                            document.body.removeChild(elem);
                        }}
                        secondaryButtonTitle="Close"
                        autoOverflowContent={true}
                    >
                        <pre className="regular-body-text" style={{ overflow: 'hidden' }}>{this.state.showMessageDetailsModal ? this.state.messageDetails : ''}</pre>
                    </ModalScreen>
                    <InPageDialog
                        showDialog={this.state.showDialog}
                        type={'error'}
                        message={this.props.pendingError}
                        closeMethod={() => this.setState({ showDialog: false, pendingError: '' })} />
                    <HandleError
                        error={this.props.fetchHistoryLog}
                    />
                    {Boolean(!this.props.shipmentType) ? '' : costAndRevenue}
                    <div className="historyLogTable">
                        <Accordion title={this.props.shipmentType ? 'Interfaces Log' : 'Invoices Log'} id="interfaces-log">
                            <div id={`${this.props.shipmentId}-history`}>
                                {this.renderTableDom(this.state.response, historyLogCols, 'historylog-', 'response')}
                            </div>
                        </Accordion>
                    </div>
                </Page>
            </React.Fragment>
        );
    }

    public renderTableDom = (tableData: any[], tableCols: any[], tableName: string, stateTarget: string) => {
        return <DataTable
            data={tableData}
            columns={tableCols}
            name={tableName}
            isSortable={true}
            isResizable={true}
            hasFooter={false}
            showColumnOptions={false}
            showPagination={false}
            isExpandable={false}
            defaultPageSize={100}
            manualPagination={true}
            linkAction={this.linkAction}
            fetchData={(data: any) => {
                if (data && data.sorted && data.sorted[0]) {
                    const dataType = tableCols.find((column: any) => column.accessor === data.sorted[0].id)?.dataType;
                    this.sortData(data, stateTarget, dataType);
                }
            }}
        />;
    };
    public sortData = (tableData: any, target: string, dataType: string) => {
        if (tableData.sorted && tableData.sorted[0]) {
            if (target === 'cost' || target === 'revenue') {
                this.parseCostAndRevenue({
                    sortBy: tableData.sorted[0].id,
                    direction: tableData.sorted[0].desc,
                    target,
                    dataType
                }, this);
            } else {
                const cloneData = [...this.state[target]];
                const newData = sortElementByKey(cloneData, tableData.sorted[0].id, tableData.sorted[0].desc, dataType);
                this.setState({ response: newData });
            }
        }
    };
    public getAction = (action: string) => {
        if (action && ActionTexts[action] && this.props.shipmentType && ActionTexts[action][getType(this.props.shipmentType)]) {
            return ActionTexts[action][getType(this.props.shipmentType)];
        }
        return action && ActionTexts[action] && ActionTexts[action].label ? ActionTexts[action].label : action.replace(/([a-z])([A-Z])/g, '$1 $2');
    };
    public linkAction = (row: any) => {
        this.props.fetchBlob(row.id);
        this.setState({
            showMessageDetailsModal: true,
            messageDetails: row.json ? JSON.stringify(JSON.parse(row.json), null, 4) : 'No Data found'
        });
    };
    public hideMessageDetailsModal = () => this.setState({ showMessageDetailsModal: false });
    public parseResponse = () => {
        const data = this.props.response.map(logEntity => {
            return {
                generatedTimestamp: formatDate(logEntity.generatedTimestamp, 'YYYY-MM-DD HH:mm:ss'),
                id: logEntity.id,
                action: this.getAction(logEntity.action),
                description: formatValueIfNullOrUndefined(logEntity.description),
                messageType: formatValueIfNullOrUndefined(logEntity.messageType),
                source: formatValueIfNullOrUndefined(logEntity.source),
                destination: formatValueIfNullOrUndefined(logEntity.destination),
                status: formatValueIfNullOrUndefined(logEntity.status),
                userId: formatValueIfNullOrUndefined(logEntity.userId),
                messageDetails: logEntity.isHavingDetailsSaved && this.IsMockAcknowledgementNotFromNftp(logEntity) ? 'Details' : ''
            };
        });
        const newData = sortElementByKey([...data], 'generatedTimestamp', true, 'date');
        this.setState({ response: newData });
    };

    public IsMockAcknowledgementNotFromNftp = (logEntity: IHistoryLogModel): boolean => {
        const validAction = [
            'salesorderupdatereceive',
            'salesordercreatereceive',
            'salesordercancelreceive'
        ];

        return !(
            this.props.isNftpBillable &&
            validAction.includes(logEntity.action?.toLowerCase()) &&
            logEntity.source?.toLowerCase() === 's4' &&
            logEntity.destination?.toLowerCase() === 'finops' &&
            logEntity.status?.toLowerCase() === 'success'
        );
    };

    public parseCostAndRevenue = (sortingData?: any, scope?: any) => {
        const cost: any[] = [];
        const revenue: any[] = [];
        const isHighlighted = (list: any[], fieldName: string | string[], value: string) => {
            const lowerList = list.map((val: any) => val.toLowerCase());
            let resp: any = lowerList.includes(fieldName.toString().toLowerCase()) ? 'highlight' : '';
            if (Array.isArray(fieldName)) {
                resp = '';
                fieldName.forEach((key: string) => {
                    if (lowerList.includes(key.toLowerCase())) {
                        resp = 'highlight';
                    }
                });
            }
            return <label className={resp} dangerouslySetInnerHTML={{ __html: formatValueIfNullOrUndefined(value) }} />;
        };
        let propsData;
        if (this.props.shipmentType === 'ets') {
            propsData = scope ? scope.props.costAndRevenue.result : this.props.costAndRevenue.result;
        } else {
            propsData = scope ? scope.props.costAndRevenue.data : this.props.costAndRevenue.data;
        }
        if (propsData) {
            const sortedData = !sortingData ?
                sortElementByKey([...propsData], 'actionDateTime', true, 'date') :
                sortElementByKey([...propsData], sortingData.sortBy, sortingData.direction, sortingData.dataType);
            sortedData.forEach((logEntity: any) => {
                logEntity.party = logEntity.party || logEntity.payToParty || logEntity.billToParty || '';
                const data = {
                    actionDateTime: isHighlighted(logEntity.changedFields, 'actionDateTime', formatDate(logEntity.actionDateTime, 'YYYY-MM-DD HH:mm:ss')),
                    chargeItem: isHighlighted(logEntity.changedFields, 'materialCode', formatValueIfNullOrUndefined(logEntity.chargeItem)),
                    chargeDescription: isHighlighted(logEntity.changedFields, 'materialDescription', formatValueIfNullOrUndefined(logEntity.chargeDescription)),
                    itemNumber: isHighlighted(logEntity.changedFields, 'itemNumber', formatValueIfNullOrUndefined(logEntity.itemNumber)),
                    action: isHighlighted(logEntity.changedFields, 'action', formatValueIfNullOrUndefined(logEntity.action)),
                    changedBy: isHighlighted(logEntity.changedFields, 'changedBy', formatValueIfNullOrUndefined(logEntity.changedBy)),
                    uom: isHighlighted(logEntity.changedFields, 'uom', formatValueIfNullOrUndefined(logEntity.uom)),
                    status: isHighlighted(logEntity.changedFields, 'status', formatValueIfNullOrUndefined(logEntity.status)),
                    rate: isHighlighted(logEntity.changedFields, 'rate', formatValueIfNullOrUndefined(logEntity.rate)),
                    quantity: isHighlighted(logEntity.changedFields, 'totalQuantity', formatValueIfNullOrUndefined(logEntity.quantity)),
                    party: isHighlighted(logEntity.changedFields, ['payToParty', 'billToParty'], formatValueIfNullOrUndefined(logEntity.party)),
                    serviceProvider: isHighlighted(logEntity.changedFields, 'serviceProvider', formatValueIfNullOrUndefined(logEntity.serviceProvider)),
                    icbIndicator: isHighlighted(logEntity.changedFields, 'icbIndicator', formatValueIfNullOrUndefined(logEntity.icbIndicator)),
                    vatPartner: isHighlighted(logEntity.changedFields, 'vatPartner', formatValueIfNullOrUndefined(logEntity.vatPartner)),
                    condCurrency: isHighlighted(logEntity.changedFields, 'condCurrency', formatValueIfNullOrUndefined(logEntity.condCurrency)),
                    rateDetailId: this.props.shipmentType === 'ets' ? isHighlighted(logEntity.changedFields, 'rateDetailId', formatValueIfNullOrUndefined(logEntity.issoRateDetailId)) : isHighlighted(logEntity.changedFields, 'rateDetailId', formatValueIfNullOrUndefined(logEntity.rateDetailId)),
                    athenaRateIdentifier: isHighlighted(logEntity.changedFields, 'athenaRateIdentifier', formatValueIfNullOrUndefined(logEntity.athenaRateIdentifier)),
                    athenaSecondaryRateIdentifier: isHighlighted(logEntity.changedFields, 'athenaSecondaryRateIdentifier', formatValueIfNullOrUndefined(logEntity.athenaSecondaryRateIdentifier)),
                    reasonDescription: isHighlighted(logEntity.changedFields, 'reasonDescription', formatValueIfNullOrUndefined(logEntity.reasonDescription)),
                    serviceRenderedAt: isHighlighted(logEntity.changedFields, 'serviceRenderedAt', formatValueIfNullOrUndefined(logEntity.serviceRenderedAt)),
                    passThrough: isHighlighted(logEntity.changedFields, 'passThrough', formatValueIfNullOrUndefined(logEntity.passThrough)),
                    chargeType: isHighlighted(logEntity.changedFields, 'chargeType', formatValueIfNullOrUndefined(logEntity.chargeType)),
                    applicability: isHighlighted(logEntity.changedFields, 'applicability', formatValueIfNullOrUndefined(logEntity.applicability)),
                    dynamicFields: isHighlighted(logEntity.changedFields, 'dynamicFields', this.extractDynamicFieldValues(logEntity.dynamicFields)),
                    blockedType: isHighlighted(logEntity.changedFields, 'blockedType', this.getBlockedTypeLabel(logEntity.blockedType)),
                };
                if (logEntity.itemCategory === 'COST') {
                    cost.push(data);
                } else {
                    revenue.push(data);
                }
            });
            if (sortingData && sortingData.target) {
                if (sortingData.target === 'cost') {
                    this.setState({ cost: [...cost] });
                } else {
                    this.setState({ revenue: [...revenue] });
                }
            } else {
                this.setState({
                    cost: [...cost],
                    revenue: [...revenue]
                });
            }
        }
    };

    public getBlockedTypeLabel = (blockedType: string) => {
        switch (blockedType) {
            case 'UNBLOCK':
                return '';
            case 'AMENDMENT':
                return 'AMENDMENT - ICP';
            case 'INVOICE':
                return 'INVOICE - ICP';
            default:
                return blockedType;
        }
    };
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.historyLog.isFetchDataLoading || state.invoices.isFetchHistoryLoading || state.historyLog.isFetchDataLoadingCV,
    isFetchDataError: state.historyLog.isFetchDataError || state.invoices.isFetchHistoryLoadingError || state.historyLog.isFetchDataErrorCV || Boolean(state.historyLog.blobError),
    pendingError: state.historyLog.pendingError || state.invoices.historyError || state.historyLog.pendingErrorCV || state.historyLog.blobError,
    response: state.historyLog.response,
    costAndRevenue: state.historyLog.costAndRevenue,
    blob: state.historyLog.blob
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchHistoryLog: (shipmentId: string, shipmentType: any) => dispatch(fetchHistoryLog(shipmentId, shipmentType)),
    fetchHistoryLogCostAndRevenue: (shipmentId: string, shipmentType: string | number) => dispatch(fetchHistoryLogCostAndRevenue(shipmentId, shipmentType)),
    fetchBlob: (shipmentId: string) => dispatch(fetchBlob(shipmentId))
});

export const HistoryLog = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_HistoryLog);


